import { FC, InputHTMLAttributes, FormEvent } from 'react';
import { Fieldset, TextInput, Button, Label, Form } from './Input.styles';
import { SearchOutlined } from '@mui/icons-material';

type InputProps = TextInputProps | SearchInputProps;

interface TextInputProps extends InputHTMLAttributes<HTMLInputElement> {
	variant?: 'text' | 'password';
	label?: string;
	icon?: JSX.Element;
}

interface SearchInputProps extends InputHTMLAttributes<HTMLInputElement> {
	variant?: 'search';
	onSearch?: () => void;
}

const Input: FC<InputProps> = ({
	variant = 'default',
	value,
	onChange,
	placeholder,
	className,
	...rest
}) => {
	if (variant === 'search') {
		const { onSearch } = rest as SearchInputProps;

		const handleSubmit = (ev: FormEvent<HTMLFormElement>) => {
			ev.preventDefault();
			onSearch?.();
		};

		return (
			<Form onSubmit={handleSubmit}>
				<Fieldset>
					<TextInput value={value} onChange={onChange} placeholder='Procurar por' />
					<Button>{onSearch ? <SearchOutlined /> : null}</Button>
				</Fieldset>
			</Form>
		);
	}

	if (variant === 'text' || variant === 'password') {
		const {
			label,
			icon,
			name = '',
			maxLength,
			type = variant,
			accept,
			readOnly,
			style,
			min,
			max,
		} = rest as TextInputProps;

		return (
			<div className={className}>
				{!!label ? <Label>{label}</Label> : null}
				<Fieldset>
					<TextInput
						value={value}
						onChange={onChange}
						placeholder={placeholder ?? label}
						name={name}
						maxLength={maxLength}
						type={type}
						accept={accept}
						readOnly={readOnly}
						style={style}
						min={min}
						max={max}
					/>
					{icon}
				</Fieldset>
			</div>
		);
	}

	return null;
};

export default Input;
